import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CheckIcon } from "../../SvgComponents/CheckIcon/CheckIcon";
import { CancelIcon } from "../../SvgComponents/CancelIcon/CancelIcon";
import { Modal } from "antd";

export const WalletOptionalModal = ({ openWalletOptionalModal, setOpenWalletOptionalModal, startCorrectSignMethod, setProviderAuth, setOpenSSIModal }) => {
    const { t } = useTranslation();

    return (
        <Modal
            title=""
            footer={null}
            open={openWalletOptionalModal}
            closable={false}
        >
            <div className="modal-container">
                {t("sign.wallet_optional_description")}
            </div>
            <Row className="action-buttons mobile-button">
                <Col md={6} xs={6}>
                    <button
                        type="button"
                        className="btn btn-primary btn-cancel"
                        onClick={() => { setOpenWalletOptionalModal(false); startCorrectSignMethod() }}
                    >
                        <span className="cancel-text">{t("general.no")}</span>
                        <CancelIcon />
                    </button>
                </Col>
                <Col md={6} xs={6}>
                    <button
                        type="button"
                        className="btn btn-primary btn-active"
                        onClick={() => { setOpenWalletOptionalModal(false); setProviderAuth('Wallet'); setOpenSSIModal(true); }}
                    >
                        <span className="cancel-text">{t("general.yes")}</span>
                        <CheckIcon />
                    </button>
                </Col>
            </Row>
        </Modal>
    );
}; 